// extracted by mini-css-extract-plugin
module.exports = {"tabHead":"tabHead-3WCDrHgl clearfix","tabHeadItem":"tabHeadItem-3Jyjv1RI","current":"current-2Tk3ZwbH"};